import styled from 'styled-components';

import { spaceL, spaceS } from '@xing-com/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 100%;
  margin-left: calc(-1 * ${spaceS});
  margin-right: calc(-1 * ${spaceS});
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: ${spaceL};
  padding-right: ${spaceS};
  padding-left: ${spaceS};
  &.loggedInWrapper {
    position: relative;
    max-width: 100%; /* Adjust as needed */
  }
  &.loggedOutWrapper {
    max-width: calc(100% / 4); /* Adjust as needed */
  }

  @media (min-width: 560px) {
    &.loggedInWrapper,
    &.loggedOutWrapper {
      max-width: calc(100% / 2); /* Adjust for medium screens */
    }
  }

  @media (min-width: 740px) {
    &.loggedOutWrapper {
      max-width: calc(100% / 3); /* Adjust for tablets */
    }
  }

  @media (min-width: 1024px) {
    &.loggedInWrapper {
      max-width: calc(100% / 3); /* Adjust for wide desktop screens */
    }
    &.loggedOutWrapper {
      max-width: calc(100% / 4); /* Adjust for wide desktop screens */
    }
  }

  @media (min-width: 1259px) {
    &.loggedOutWrapper {
      max-width: calc(100% / 5); /* Adjust for navigation media */
    }
  }
`;
